import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Label,
  Button
} from "reactstrap";
import Select from "react-select";
import { DataTable, TableRowField, ExportCSV } from "../../../../components";
import { getInventory } from "../../../../store/report/actions";
import { getStores, resetStores } from "../../../../store/store/actions";
import { messages, layout, roles } from "../../../../common/constants";
import MediaQuery from "react-responsive";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { selectStoresForSelect } from "../../../../store/store/selector";
import { formatHelper } from "../../../../common/helpers";
import { getInventory as productInventoryExport } from "../../../../service/report";
import { selectUserRole } from "../../../../store/user/selector";

class Inventory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      selectedStore: null,
      productInventoryExport: []
    };
    this.handleObtainReportExport = this.handleObtainReportExport.bind(this);
    this.handleExportCSV = this.handleExportCSV.bind(this);

    this.handleStoreChange = this.handleStoreChange.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  async componentDidMount() {
    await this.props.getStores({ reset: true });
    await this.performGetInventory(true);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.stores.length == 0 && this.props.stores.length > 0) {
      this.setState({ selectedStore: this.props.stores[0] });
    }
  }

  performGetInventory(reset = false) {
    const { getInventory, stores } = this.props;
    const { page, selectedStore } = this.state;

    if (stores.length == 0) return;

    var storeId = 0;
    if (selectedStore) storeId = selectedStore.value;
    getInventory({ page, storeId, reset });
  }

  async handleStoreChange(value) {
    if (value == this.state.selectedStore) return;
    await this.setState({ selectedStore: value, page: 1 });
    this.performGetInventory();
  }

  async handlePageChange(page) {
    await this.setState({ page: page });
    this.performGetInventory();
  }
  renderDataTable(columns) {
    return (
      <DataTable
        data={this.props.inventory}
        keyField="Product.id"
        columns={columns}
        page={this.state.page}
        totalSize={this.props.total}
        sizePerPage={this.props.pageSize}
        loading={this.props.loading}
        onPageChange={this.handlePageChange}
      />
    );
  }

  async handleObtainReportExport() {
    await productInventoryExport(0, this.state.selectedStore.value).then(
      response => {
        this.setState({
          productInventoryExport: response.data.data
        });
      }
    );
    this.handleExportCSV();
  }

  handleExportCSV() {
    var csvRow = [];
    var A = [["Orden", "Producto", "Cantidad", "Stock Mínimo", "Tienda"]];
    var re = this.state.productInventoryExport;

    var storeName = "";

    for (var item = 0; item < re.length; item++) {
      A.push([
        item + 1,
        re[item].Product.name,
        re[item].quantity,
        re[item].minStock,
        re[item].Store.name
      ]);
      storeName = re[item].Store.name;
    }

    for (var item = 0; item < A.length; item++) {
      A[item][1] = String(A[item][1]).replace(/\s/g, " ");
      A[item][4] = String(A[item][4]).replace(/\s/g, " ");
      csvRow.push(A[item].join(","));
    }
    storeName = String(storeName).replace(/\s/g, '_');
    var csvString = csvRow.join("\r\n");

    var a = document.createElement("a");
    a.href = 'data:attachment/csv;charset=utf-16le,%EF%BB%BF' + encodeURI(csvString)
    a.target = "_Blank";
    a.download =
      this.state.selectedStore.value == 0
        ? formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-general-productos-inventario.csv"
        : formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-productos-inventario_" +
        storeName.toLowerCase() +
        ".csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a)
  }

  render() {
    const columnsXS = [
      {
        dataField: "xs",
        text: "Detalle de Inventario",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField label="Producto:" value={row.Product.name} />
              <TableRowField label="Cantidad:" value={row.quantity} />
              <TableRowField label="Minimo Stock:" value={row.minStock} />
              <TableRowField label="Tienda:" value={row.Store.name} />
            </div>
          );
        }
      }
    ];
    const columnsSM = [
      {
        dataField: "xs",
        text: "Detalle de Inventario",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField label="Producto:" value={row.Product.name} />
              <TableRowField label="Cantidad:" value={row.quantity} />
              <TableRowField label="Minimo Stock:" value={row.minStock} />
            </div>
          );
        }
      },
      {
        dataField: "store",
        text: "Tienda",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField label="" value={row.Store.name} />
            </div>
          );
        }
      }
    ];
    const columnsMD = [
      {
        dataField: "product",
        text: "Producto",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField label="" value={row.Product.name} />
            </div>
          );
        }
      },
      {
        dataField: "quantity",
        text: "Cantidad"
      },
      {
        dataField: "minStock",
        text: "Minimo Stock"
      },
      {
        dataField: "store",
        text: "Tienda",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField label="" value={row.Store.name} />
            </div>
          );
        }
      }
    ];

    return (
      <div className="animated">
        <Card>
          <CardHeader>
            <i className="icon-chart" />Inventario de Productos
          </CardHeader>
          <CardBody>

            <Row className="mb-2">
              <Col md="9">
                <Row>
                  {(this.props.role == roles.SUPER_ADMIN ||
                    this.props.role == roles.ADMIN) && (
                      <Col>
                        <Row>
                          <Col md="1">
                            <Label className="mt-2">Tienda:</Label>
                          </Col>
                          <Col md="8">
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              isLoading={this.props.loadingStores}
                              isSearchable={true}
                              noOptionsMessage={() => {
                                return messages.SELECT_NO_OPTIONS;
                              }}
                              placeholder=""
                              options={this.props.stores}
                              loadingMessage={() => {
                                return messages.SELECT_LOADING;
                              }}
                              onChange={this.handleStoreChange}
                              value={this.state.selectedStore}
                              isDisabled={this.props.loadingStores}
                            />
                          </Col>
                        </Row>
                      </Col>
                    )}
                </Row>
              </Col>
              <Col md="3">
                <ExportCSV
                  exportCSV={this.handleObtainReportExport}
                  minWidth={800}
                />
              </Col>
            </Row>
            <hr className="my-4" />
            <Row>
              <Col>
                <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                  {this.renderDataTable(columnsXS)}
                </MediaQuery>
                <MediaQuery
                  minWidth={layout.SM_MIN_WIDTH}
                  maxWidth={layout.MD_MAX_WIDTH}
                >
                  {this.renderDataTable(columnsSM)}
                </MediaQuery>
                <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                  {this.renderDataTable(columnsMD)}
                </MediaQuery>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    inventory,
    total,
    pageSize,
    error,
    loading
  } = state.report.inventoryList;
  return {
    inventory,
    total,
    pageSize,
    error,
    loading,
    stores: selectStoresForSelect(state),
    loadingStore: state.store.storeList.loading,
    role: selectUserRole(state)
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getInventory,
      getStores,
      resetStores
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Inventory);



// WEBPACK FOOTER //
// ./src/scenes/Report/StockMovement/Inventory/Inventory.js